import { GlobalSearchDataContext, GlobalSearchDataContextType } from "modules/cached-data/src/global-search-data/global-search-data-context"
import { useContext } from "react"

export function useGlobalSearchData (): GlobalSearchDataContextType {
    return useContext( GlobalSearchDataContext )
}
